import template from './ticketsFilter.template.html';

export default {
  template,
  bindings: {
    filters: '<',
    accounts: '<',
    partners: '<',
    stages: '<',
    ticketLabels: '<',
    isEnterprise: '<',
    onApplied: '&',
    onClosed: '&'
  },
  controller: class controller {
    constructor(
      $state,
      $rootScope,
      $filter,
      $mdMedia,
      $timeout,
      actionService,
      dateTimeService,
      Filter,
      FilterType,
      filterService,
      filtersService,
      uiService,
      TICKET
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.model = {};
      ctrl.currentState = $state.current.name;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.canSeeNeedsAnalysis = $rootScope.canSeeNeedsAnalysis();
      ctrl.canSeeAccountsAsPartnersOption = $rootScope.canSeeAccountsAsPartnersOption();
      ctrl.filtersList = null;
      ctrl.hasSelection = false;
      ctrl.isEditing = false;
      ctrl.isVisible = false;
      ctrl.isReady = true;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.filters = ctrl.filters || [];
        ctrl.accounts = ctrl.accounts || [];
        ctrl.partners = ctrl.partners || [];
        ctrl.stages = ctrl.stages || [];
        ctrl.ticketLabels = ctrl.ticketLabels || [];

        ctrl.isVisible = true;
      };

      ctrl.listChange = (list, data, isSelected) => {
        ctrl.hasSelection = isSelected || list.isSelectedAny();
      };

      ctrl.listReady = (list) => {
        ctrl.filtersList = list;
      };

      ctrl.operatorToggle = (prop) => {
        ctrl.model[prop].operatorNot = !ctrl.model[prop].operatorNot;
      };

      ctrl.operatorClass = (prop) => ({
        'fab-red-hover': ctrl.model[prop].operatorNot === true,
        'fab-green-hover': ctrl.model[prop].operatorNot === false
      });

      ctrl.filterEdit = ($event, filter) => {
        $event.stopPropagation();
        ctrl.isEditing = true;
        ctrl.filter = filter || Filter.blank();

        // Init Filter model with Template
        ctrl.model = filterService.modelCompose(ctrl.filter, TICKET.FILTERS, {
          STAGE: ctrl.stages,
          OWNER: ctrl.accounts,
          TEAM_MEMBER: ctrl.account,
          PARTNER: ctrl.partners,
          REFERRER: ctrl.accounts,
          LABEL: ctrl.ticketLabels
        });

        // Remap Name back to Model
        ctrl.model.name =
          _.get(ctrl.filter, 'name') || `Deal filter ${ctrl.filters.length + 1}`;

        dateTimeService.getSet(
          ctrl,
          ctrl.model.EXPECTED_CLOSE_DATE,
          'values[0]',
          'getSetDueDateFrom'
        );
        if (ctrl.model.EXPECTED_CLOSE_DATE.values[0]) {
          ctrl.getSetDueDateFrom(
            moment.utc(ctrl.model.EXPECTED_CLOSE_DATE.values[0], 'X').format('YYYY-MM-DD')
          );
        }
        dateTimeService.getSet(
          ctrl,
          ctrl.model.EXPECTED_CLOSE_DATE,
          'values[1]',
          'getSetDueDateTo'
        );
        if (ctrl.model.EXPECTED_CLOSE_DATE.values[1]) {
          ctrl.getSetDueDateTo(
            moment.utc(ctrl.model.EXPECTED_CLOSE_DATE.values[1], 'X').format('YYYY-MM-DD')
          );
        }

        dateTimeService.getSet(
          ctrl,
          ctrl.model.CREATION_DATE,
          'values[0]',
          'getSetCreationDateFrom'
        );
        if (ctrl.model.CREATION_DATE.values[0]) {
          ctrl.getSetCreationDateFrom(
            moment.utc(ctrl.model.CREATION_DATE.values[0], 'X').format('YYYY-MM-DD')
          );
        }
        dateTimeService.getSet(
          ctrl,
          ctrl.model.CREATION_DATE,
          'values[1]',
          'getSetCreationDateTo'
        );
        if (ctrl.model.CREATION_DATE.values[1]) {
          ctrl.getSetCreationDateTo(
            moment.utc(ctrl.model.CREATION_DATE.values[1], 'X').format('YYYY-MM-DD')
          );
        }
      };

      ctrl.filterApply = ($event, filterToApply, isList) => {
        $event.stopPropagation();

        if (isList) {
          ctrl.onApplied({
            idFilter: filterToApply.id,
            filterName: filterToApply.name
          });
          ctrl.isReady = false;
          return;
        }

        ctrl.filter.type = FilterType.ticket;
        ctrl.filter.isEnterprise = ctrl.isEnterprise;
        ctrl.filter.name = ctrl.model.name || `Deal filter ${ctrl.filters.length + 1}`;
        ctrl.filter.items = filterService.modelDecompose(ctrl.model);

        if (_.isEmpty(ctrl.filter.id)) {
          filterService.createFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: data.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        } else {
          filterService.updateFilter(ctrl.filter).then((data) => {
            if (data.status) {
              ctrl.onApplied({ idFilter: ctrl.filter.id, filterName: ctrl.filter.name });
              ctrl.isReady = false;
            } else {
              uiService.toast({
                text: {
                  p1: 'Failed to',
                  p2: 'save',
                  p3: 'your changes'
                },
                warn: true
              });
            }
          });
        }
      };

      ctrl.filterDelete = () => {
        filtersService.clearCache();
        actionService
          .deleteDocuments(
            ctrl.filtersList.getSelected(),
            filterService.deleteFilter,
            ctrl.filtersList.removeData,
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterDuplicate = () => {
        filtersService.clearCache();
        actionService
          .duplicateDocuments(
            ctrl.filtersList.getSelected(),
            filterService.readFilter,
            filterService.createFilter,
            ctrl.filtersList.setDataAppend,
            'name',
            ' copy',
            'filter(s)'
          )
          .then(() => {
            ctrl.hasSelection = false;
          });
      };

      ctrl.filterClose = () => {
        ctrl.isReady = false;
        ctrl.onClosed();
      };

      ctrl.filterCancel = ($event) => {
        $event.stopPropagation();
        ctrl.isEditing = false;
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        $timeout(() => {
          ctrl.initialize();
        }, 250);
      };
    }
  }
};
